import {put, takeLatest, call} from 'redux-saga/effects';
import * as categoryService from "../../../services/categoryService";
import {
    UPDATE_CATEGORY,
    UPDATE_CATEGORY_SUCCESS,
    UPDATE_CATEGORY_ERROR,
}
    from "../../actions/category";

function* updateCategorySaga(action) {
    try {
        const data =  yield call(categoryService.UpdateCategory, action.payload)
        yield put({
            type: UPDATE_CATEGORY_SUCCESS,
            payload: data
        });


    } catch (error) {
        yield put({
            type: UPDATE_CATEGORY_ERROR,error: error.data
        });
    }
}

export function* updateCategorySagaWatcher() {
    yield takeLatest(UPDATE_CATEGORY, updateCategorySaga);
}